export const CULTURES = {
  tr: "tr-TR",
  en: "en-EN",
  az: "tr-TR",
  ru: "ru-RU",
  fa: "fa-IR",
};
